import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Landing from './pages/Landing';

const router = createBrowserRouter([
  { path: '/', element: <Landing /> },
  { path: '/app', element: <App /> },
  { path: '/privacy-policy', element: <PrivacyPolicy /> },
]);

export default router;
